import React from 'react';
import { CalendarX2Icon, LibraryIcon, LightbulbIcon } from 'lucide-react';
import { Reveal } from './Reveal';
const points = [{
  icon: LightbulbIcon,
  text: 'Se te acaban las ideas para renovar tus clases de música',
  color: 'bg-brand-yellow/15 text-brand-yellow'
}, {
  icon: CalendarX2Icon,
  text: 'No tenés tiempo de armar la planificación anual desde cero',
  color: 'bg-brand-pink/15 text-brand-pink'
}, {
  icon: LibraryIcon,
  text: 'Te faltan recursos actualizados y adaptados a cada nivel',
  color: 'bg-brand-teal/15 text-brand-teal'
}];
export function PainPointsSection() {
  return <section className="bg-brand-dark px-4 py-20 md:py-28" data-id="element-118" data-mp="3fg2c0faxek7w">
      <Reveal className="mx-auto max-w-5xl text-center" data-id="element-119" data-mp="3fhlsa5wl0v9o">
        <h2 className="text-3xl font-black text-brand-blue md:text-4xl" data-id="element-120" data-mp="3ahha8bg0zshc">🎵 ¿Te Identificás con Estas Situaciones?</h2>
        <p className="mt-4 text-brand-gray" data-id="element-121" data-mp="3ogqqtc858olu">Si respondés que sí a alguna de estas, Música Lista es para vos.</p>
        <div className="mt-12 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-122" data-mp="3kggktzkcpy6z">
          {points.map(({
          icon: PointIcon,
          text,
          color
        }) => <article key={text} className="flex items-center gap-4 rounded-2xl border border-brand-blue/[0.06] bg-brand-alt p-5 text-left shadow-sm" data-id="element-123" data-mp="ww3fwtg4sh7z">
              <span className={`flex h-11 w-11 shrink-0 items-center justify-center rounded-xl ${color}`} data-id="element-124" data-mp="11tv8zqsii9dr">
                <PointIcon className="h-6 w-6" aria-hidden="true" data-id="element-125" data-mp="16vudj3zzncca" />
              </span>
              <span className="text-sm font-semibold leading-snug" data-id="element-126" data-mp="1bt49l2hvum93">{text}</span>
            </article>)}
        </div>
        <p className="mt-12 font-serif text-2xl font-bold italic text-brand-purple" data-id="element-127" data-mp="1fsuvoswgse7a">Te merecés mucho más que eso.</p>
      </Reveal>
    </section>;
}